import React, { useState } from "react";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you might call an API to send the message
    console.log(formData);
    alert("Nachricht gesendet!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="bg-black text-white min-h-screen w-full pt-16 pb-20">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-xl mx-auto">
          <div className="border-l-4 border-teal-400 pl-6 mb-8">
            <h1 className="text-3xl font-bold text-white">Kontakt</h1>
            <p className="text-gray-400 mt-2">Senden Sie uns eine Nachricht</p>
          </div>
          
          <div className="bg-gray-900 bg-opacity-50 rounded-lg p-8 shadow-xl">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block mb-2 text-gray-200 font-medium">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full p-3 rounded-lg bg-black border border-gray-700 focus:border-teal-400 focus:ring-1 focus:ring-teal-400 focus:outline-none transition duration-200"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block mb-2 text-gray-200 font-medium">
                  E-Mail
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 rounded-lg bg-black border border-gray-700 focus:border-teal-400 focus:ring-1 focus:ring-teal-400 focus:outline-none transition duration-200"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block mb-2 text-gray-200 font-medium">
                  Nachricht
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full p-3 rounded-lg bg-black border border-gray-700 focus:border-teal-400 focus:ring-1 focus:ring-teal-400 focus:outline-none transition duration-200"
                  rows="5"
                  required
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="px-6 py-3 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition duration-300 shadow-lg"
              >
                Absenden
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}